<template>
  <span>
    <tooltip :text="$t('components.template.editor.placeholder.title')">
      <v-btn small icon @click="placeholderDialog = !placeholderDialog">
        <v-icon>mdi-keyboard-space</v-icon>
      </v-btn>
    </tooltip>
    <confirm-action-dialog
      v-if="placeholderDialog"
      :isDialogActive.sync="placeholderDialog"
      :title="$t('components.template.editor.placeholder.title')"
      :rightLabel="$t('components.template.editor.placeholder.confirm')"
      :supressKeyboardCancel="true"
      @rightClick="onSelect"
      @leftClick="placeholderDialog = false"
    >
      <template-editor-placeholder-dropdown :partnerId="partnerId" ref="dropdown" />
    </confirm-action-dialog>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import Tooltip from "../utility/tooltip.vue";
import TemplateEditorPlaceholderDropdown from "./TemplateEditorPlaceholderDropdown.vue";

@Component({
  components: { Tooltip, ConfirmActionDialog, TemplateEditorPlaceholderDropdown }
})
export default class TemplateEditorAddPlaceholder extends Vue {
  @Prop()
  partnerId?: string;

  placeholderDialog = false;

  /**
   * Verify the token category and emit
   */
  onSelect() {
    const placeholder = (this.$refs.dropdown as TemplateEditorPlaceholderDropdown).select();

    this.$emit("addPlaceholder", placeholder);
    this.placeholderDialog = false;
  }
}
</script>

<style scoped>
.scrollable {
  overflow-y: auto;
}
</style>
